module.exports = __webpack_public_path__ + "static/media/i_featured_doc.523c18f3.svg";